import { notification } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from 'src/components/Form/TextField';
import { ValidationRules } from 'src/components/Form/ValidationRules';
import { Modal } from 'src/components/Modal/Modal';
import {
    ProcessStoreClass,
    ProcessStoreProvider,
} from 'src/stores/ProcessStore/ProcessStore';
import { ProcessName } from 'src/types/processName';
import { ConstraintViolationError } from 'src/utils/ErrorDataHelper';
import { FormHelper } from 'src/utils/FormHelper';
import { addModalRenderer, ModalRendererProps } from 'src/utils/ModalRenderer';

export type InvitePartnerDialogProps = ModalRendererProps<{
    partnerId: string | number;
}>;

const InvitePartnerDialogFn = observer(
    ({ partnerId, ...props }: InvitePartnerDialogProps) => {
        const { t } = useTranslation();

        useEffect(() => {
            return () => {
                store.submitProcessLoader.reset();
            };
        }, []);

        const fields = FormHelper.getFieldDataItems(
            store.submitProcessLoader.errorData as ConstraintViolationError,
        );

        const onFinish = async (values: InviteParnterFormValues) => {
            await store.submit({
                partnerId: String(partnerId),
                username: values.username,
            });
            if (!store.submitProcessLoader.hasError) {
                notification.success({
                    message: t('App.InvitePartnerDialog.SendSuccess'),
                });
            } else {
                return Promise.reject();
            }
        };

        return (
            <Modal
                title={t('App.InvitePartnerDialog.Title')}
                okText={t('App.InvitePartnerDialog.SendInvitation')}
                headerExtra={t('App.InvitePartnerDialog.SubTitle')}
                isLoading={store.submitProcessLoader.isLoading}
                onFinish={onFinish}
                formProps={{ fields }}
                {...props}
            >
                <TextField
                    name={formNames.getPath('username')}
                    label={t('App.InvitePartnerDialog.Username')}
                    rules={[ValidationRules.required, ValidationRules.email]}
                />
            </Modal>
        );
    },
);

type InviteParnterFormValues = {
    username: string;
};

type InvitePartnerProcessPayload = {
    partnerId: string;
    username: string;
};

const formNames = FormHelper.createNameProvider<InviteParnterFormValues>();
const store = ProcessStoreProvider.getInstance<
    ProcessStoreClass<InvitePartnerProcessPayload>
>(ProcessName.InvitePartnerProcess);

export const InvitePartnerDialog = addModalRenderer(InvitePartnerDialogFn);
